<template>
  <div class="container">
    <el-button type="text" class="btn" @click="setUncheckedDishList">刷新</el-button>
    <el-table :data="unCheckList" style="width: 100%">
      <el-table-column prop="eatery_name" header-align="center" align="center" label="食堂"></el-table-column>
      <el-table-column label="餐厅" header-align="center" align="center">
        <template slot-scope="scope">{{ scope.row.canteen.canteen_name }}</template>
      </el-table-column>
      <el-table-column header-align="center" align="center" label="待审核碗碟个数">
        <template slot-scope="scope">{{ scope.row.dish_list.length || 0 }}</template>
      </el-table-column>
      <el-table-column header-align="center" align="center" label="状态">
        <template slot-scope="scope">
          <el-tag type="success">{{scope.row.state === 3 || scope.row.state === 4 ? '已审核' : '未审核'}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column header-align="center" align="center" label="操作">
        <template slot-scope="scope">
          <el-button
            type="text"
            :disabled="scope.row.state === 4 || scope.row.state === 3"
            @click="check(scope.row)"
          >审核</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { apiQueryAllCachedDishes } from "@/api";
import { mapGetters, mapMutations, mapActions } from "vuex";

export default {
  name: "",
  components: {},
  data() {
    return {
      cachedDishes: []
    };
  },
  mounted() {
    // this.queryAllCachedDishes();
    this.setSubTitle("碗碟审核");
    this.setUncheckedDishList();
  },
  methods: {
    ...mapMutations(["setSubTitle"]),
    ...mapActions(["setUncheckedDishList"]),
    check(row) {
      this.$router.push({
        path: "dishCheckProcess",
        query: {
          batchInfo: row
        }
      });
    }
  },
  computed: {
    ...mapGetters(["uncheckedDishList"]),
    unCheckList() {
      return this.uncheckedDishList.map(cached => {
        if (cached.state === 3 || cached.state === 4) {
          this.$set(cached, "checked", true);
          return cached;
        }
        return cached;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  position: relative;
  .btn {
    position: absolute;
    top: 4px;
    left: 0;
    z-index: 10;
  }
}
</style>
